<script lang="ts">
  interface Props {
    sourceType: 'webhook' | 'weather' | 'email';
    disabled?: boolean;
    onChange: (value: 'webhook' | 'weather' | 'email') => void;
  }

  let { sourceType, disabled = false, onChange }: Props = $props();

  const options = [
    { value: 'email',   label: 'Forwarded email', desc: 'Forward any alert email to a unique address.' },
    { value: 'weather', label: 'Weather alert',   desc: 'National Weather Service alerts for your area.' },
    { value: 'webhook', label: 'Webhook',         desc: 'POST JSON from any external service.' }
  ] as const;
</script>

<fieldset class="source-picker" {disabled}>
  <legend>Source</legend>
  {#if disabled}
    {@const selected = options.find(o => o.value === sourceType)}
    {#if selected}
      <div class="source-option selected source-option--locked">
        <span class="source-option-label">{selected.label}</span>
        <span class="source-option-desc">{selected.desc}</span>
        <span class="source-option-lock" aria-hidden="true">🔒</span>
      </div>
      <p class="source-locked-hint">Source type can't be changed after a trigger is created.</p>
    {/if}
  {:else}
    {#each options as opt}
      <label class="source-option" class:selected={sourceType === opt.value}>
        <input
          type="radio"
          name="source_type"
          value={opt.value}
          checked={sourceType === opt.value}
          onchange={() => onChange(opt.value)}
        />
        <span class="source-option-label">{opt.label}</span>
        <span class="source-option-desc">{opt.desc}</span>
      </label>
    {/each}
  {/if}
</fieldset>

<style>
  .source-picker { border: 0; padding: 0; margin: 0 0 1rem; }
  .source-option { display: flex; gap: .75rem; padding: .75rem; border: 1px solid #ddd;
                   border-radius: 6px; cursor: pointer; margin-bottom: .5rem; align-items: flex-start; }
  .source-option.selected { border-color: #2a8a3e; background: #f4faf5; }
  .source-option-label { font-weight: 600; }
  .source-option-desc { color: #666; font-size: .9rem; flex: 1; }
  .source-option--locked { cursor: default; }
  .source-option-lock { color: #888; font-size: .9rem; }
  .source-locked-hint { color: #888; font-size: .8rem; margin: .25rem 0 0; font-style: italic; }
</style>
